/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".reports[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{width:22rem;margin-top:12px}.reports[_ngcontent-%COMP%]{margin-top:2rem}\n/*# sourceMappingURL=reports.component.css.map*/"];
export { styles as styles };
